import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  class: "tw-w-full",
  ref: "root"
}
const _hoisted_2 = {
  key: 0,
  class: "tw-block tw-mb-1 tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500"
}
const _hoisted_3 = { class: "tw-relative tw-w-full" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "tw-flex tw-items-center tw-gap-2 tw-flex-shrink-0" }
const _hoisted_6 = { class: "tw-max-h-64 tw-overflow-auto tw-p-1" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "tw-truncate" }
const _hoisted_9 = {
  key: 0,
  class: "tw-px-3 tw-py-2 tw-text-sm tw-text-slate-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.textLabel)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.textLabel), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        ref: "buttonEl",
        type: "button",
        class: _normalizeClass(["tw-w-full tw-flex tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-px-3 tw-py-2 tw-text-left tw-shadow-sm tw-shadow-slate-900/5 tw-transition", [
          _ctx.disabled
            ? 'tw-bg-slate-50 tw-border-slate-200 tw-text-slate-400 tw-cursor-not-allowed'
            : 'tw-bg-white/70 tw-border-slate-200/70 tw-text-slate-900 hover:tw-bg-white',
          _ctx.isOpen && !_ctx.disabled ? 'tw-ring-4 tw-ring-indigo-500/15 tw-border-indigo-500/55' : '',
        ]]),
        disabled: _ctx.disabled,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["tw-flex-1 tw-min-w-0 tw-truncate", _ctx.selectedLabel ? 'tw-text-slate-900' : 'tw-text-slate-500'])
        }, _toDisplayString(_ctx.selectedLabel || _ctx.placeholder || 'Select…'), 3),
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_font_awesome_icon, {
            icon: "chevron-down",
            class: _normalizeClass(["tw-h-4 tw-w-4 tw-text-slate-500 tw-transition-transform", _ctx.isOpen ? 'tw-rotate-180' : ''])
          }, null, 8, ["class"])
        ])
      ], 10, _hoisted_4),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        (_ctx.isOpen && !_ctx.disabled)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref: "menuEl",
              class: "tw-fixed tw-z-[3000] tw-overflow-hidden tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white tw-shadow-xl tw-shadow-slate-900/10",
              style: _normalizeStyle(_ctx.menuStyle)
            }, [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.safeOptions, (opt, idx) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: idx,
                    type: "button",
                    class: _normalizeClass(["tw-w-full tw-flex tw-items-center tw-justify-between tw-gap-3 tw-rounded-lg tw-px-3 tw-py-2 tw-text-left tw-text-sm tw-transition", [
                _ctx.isSelected(opt) ? 'tw-bg-slate-900/5 tw-text-slate-900 tw-font-medium' : 'tw-text-slate-700 hover:tw-bg-slate-900/5',
              ]]),
                    onClick: ($event: any) => (_ctx.selectOption(opt))
                  }, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.optionLabel(opt)), 1),
                    (_ctx.isSelected(opt))
                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 0,
                          icon: "check",
                          class: "tw-h-4 tw-w-4 tw-text-slate-700 tw-flex-shrink-0"
                        }))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_7))
                }), 128)),
                (_ctx.safeOptions.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, " No options available "))
                  : _createCommentVNode("", true)
              ])
            ], 4))
          : _createCommentVNode("", true)
      ]))
    ])
  ], 512))
}